import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import { FavoriteDeliveryType } from 'types/checkout-info';
import { TFunction } from 'i18next';

type DeliverySnackText = {
  title: string;
  description: string;
};

export const getDeliverySnackText = (
  deliveryType: FavoriteDeliveryType,
  t: TFunction,
): DeliverySnackText | null => {
  switch (deliveryType) {
    case FAVORITE_DELIVERY_TYPE.HOME_DELIVERY:
      return {
        title: t('header.main.favorite-address.snack.delivery.title'),
        description: t('header.main.favorite-address.snack.delivery.description'),
      };
    case FAVORITE_DELIVERY_TYPE.PICKUP:
      return {
        title: t('header.main.favorite-address.snack.pickup.title'),
        description: t('header.main.favorite-address.snack.pickup.description'),
      };
    case FAVORITE_DELIVERY_TYPE.PICKUP_POINT:
      return {
        title: t('header.main.favorite-address.snack.pickup-point.title'),
        description: t('header.main.favorite-address.snack.pickup-point.description'),
      };
    default:
      return null;
  }
};
